import * as actions from '../actions/actionConstants.js';

const initialState = {
  organizationsList: [],
  organizations: {},
  fetchingOrganizationsStatus: ''
};

const organizationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_ORGANIZATIONS:
      return {
        ...state,
        fetchingOrganizationsStatus: 'Loading'
      };
    case actions.GET_ORGANIZATIONS_SUCCESS:
      return {
        ...state,
        organizationsList: [...action.organizationsList],
        organizations: { ...action.organizations },
        fetchingOrganizationsStatus: 'Loaded'
      };
    case actions.GET_ORGANIZATIONS_ERROR:
      return {
        ...state,
        fetchingOrganizationsStatus: 'Error'
      };
    case actions.USER_LOGOUT:
      return {
        organizationsList: [],
        organizations: {},
        fetchingOrganizationsStatus: ''
      };
    default:
      return state;
  }
};

export default organizationsReducer;



// WEBPACK FOOTER //
// ./src/reducers/organizations.js